export enum Variant {
	OneOnOnesEarlyAccess = 'one-on-ones',
	OneOnOnesLimitedRelease = 'achieve-limited-release',
	OneOnOnesExperimental = 'one-on-ones-experimental',
	OneOnOnesR3FastFollows = 'achieve-adoption-r3-fast-follows',
	OpenOneOnOnes = 'open-one-on-ones',
	EmployeeSpotlight = 'employee-spotlight',
	EmployeeSpotlightTrigger = 'employee-spotlight-triggers',
	RemoveHomepageWidgetColumn = 'remove-homepage-widget-column',
}
